<template>
  <v-text-field
    :value="show1 ? password : visiblePassword"
    :append-icon="show1 ? 'fas fa-eye' : (binding.appendIcon || '$eyesClosed')"
    type="text"
    @click:append="show1 = !show1"
    @input="onInput"
    @blur="$emit('blur')" 
    label=""
    solo
    autocomplete="off"
    readonly
    hide-details="auto"
    @focus="removeReadonly($event)"
    :error-messages="errors"
    v-bind="bindingFiltered"
  ></v-text-field>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    errors: { type: Array, default: () => [] },
    binding: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      show1: false,
      password: this.value
    };
  },
  computed: {
    visiblePassword() {
      return '*'.repeat(this.password.length);
    },
    bindingFiltered() {
      const { appendIcon, errorMessages, ...rest } = this.binding;
      return rest;
    }
  },
  watch: {
    value(newVal) {
      this.password = newVal;
    },
    password(newVal) {
      this.$emit('input', newVal);
      this.$emit('change', newVal);
    }
  },
  methods: {
    onInput(val) {
      if (this.show1) this.password = val;
      else {
        const diff = val.length - this.visiblePassword.length;
        if (diff > 0) this.password += val.slice(-diff);
        else if (diff < 0) this.password = this.password.slice(0, val.length);
      }
    },
    removeReadonly(event) {
      event.target.removeAttribute('readonly');
    }
  }
};
</script>
